import _ from "lodash";
import React from "react";
import {
  CommentOutlined,
  HelpFilled,
  NotificationBellFilled,
  NotificationBellOutlined,
  HelpOutlined,
  ChatTextFilled,
} from "@toddle-edu/ds-icons";
import {
  NOTIFICATIONS,
  HELP_CENTER,
  MESSAGING,
} from "Constants/stringConstants";
import SupportDropdown from "../SupportDropdown";
import { Badge } from "@toddle-edu/ds-web";
import ACLStore from "lib/aclStore";
import {
  MESSAGING_MODULE_OPENED_FROM,
  recordMessagingModuleOpened,
} from "MessagingV2/modules/Utils";

const _getTrayOptions = ({
  userLoggedIn,
  isIntercomV2Enabled,
  isNotificationData,
  closeAllOptions,
  selectedIcon,
  showNotificationIconGlobal,
  showSprinklrChat,
  showMessagingIcon,
  sprinklrUnreadMessageCount,
  hiddenGlobalTrayIcons,
  showIntercom,
  hoveredIcon,
}) => {
  const TRAY_OPTIONS = [
    {
      key: MESSAGING,
      icon: getMessagingIcon({ selectedIcon, hoveredIcon }),
      permAny: [],
      permAll: [showMessagingIcon],
      isHidden: _.includes(hiddenGlobalTrayIcons, MESSAGING),
      onClick: () => {
        recordMessagingModuleOpened({
          from: MESSAGING_MODULE_OPENED_FROM.MAGIC_TRAY,
        });
      },
    },
    {
      key: NOTIFICATIONS,
      icon: getNotificationIcon({
        isNotificationData,
        selectedIcon,
        hoveredIcon,
      }),
      permAny: [],
      permAll: [showNotificationIconGlobal],
      isHidden: _.includes(hiddenGlobalTrayIcons, NOTIFICATIONS),
    },
    {
      key: HELP_CENTER,
      icon: getHelpCenterIcon({
        userLoggedIn,
        closeAllOptions,
        selectedIcon,
        sprinklrUnreadMessageCount,
        hoveredIcon,
      }),
      permAny: [isIntercomV2Enabled, showSprinklrChat],
      permAll: [showIntercom],
      isHidden: _.includes(hiddenGlobalTrayIcons, HELP_CENTER),
    },
  ];
  return _.filter(TRAY_OPTIONS, option => {
    return (
      _.every(_.get(option, "permAll"), Boolean) &&
      (_.size(_.get(option, "permAny"))
        ? _.some(_.get(option, "permAny"), Boolean)
        : true) &&
      !_.get(option, "isHidden")
    );
  });
};
export const getTrayOptions = _.memoize(_getTrayOptions, param =>
  JSON.stringify(_.omit(param, ["closeAllOptions"]))
);

const _getGlobalMenuTrayCountArr = ({
  notificationCount,
  totalUnreadChatCount,
  sprinklrUnreadMessageCount,
  trayOptions,
}) => {
  const GlobalMenuTrayCountArr = [
    {
      key: NOTIFICATIONS,
      value: notificationCount,
    },
    {
      key: MESSAGING,
      value: totalUnreadChatCount,
    },
    {
      key: HELP_CENTER,
      value: sprinklrUnreadMessageCount,
    },
  ];
  return _.filter(GlobalMenuTrayCountArr, countObj => {
    return _.some(trayOptions, option => {
      return _.get(countObj, "key") === _.get(option, "key");
    });
  });
};
export const getGlobalMenuTrayCountArr = _.memoize(
  _getGlobalMenuTrayCountArr,
  param => JSON.stringify(_.omit(param, "trayOptions"))
);

const getMessagingIcon = ({ selectedIcon, hoveredIcon }) => {
  return _.isEqual(selectedIcon, MESSAGING) ? (
    <ChatTextFilled variant={"default"} size="x-small" />
  ) : (
    <CommentOutlined
      variant={_.isEqual(hoveredIcon, MESSAGING) ? "default" : "subtle"}
      size="x-small"
    />
  );
};

const getNotificationIcon = ({
  isNotificationData,
  selectedIcon,
  hoveredIcon,
}) => {
  return _.isEqual(selectedIcon, NOTIFICATIONS) ? (
    <NotificationBellFilled
      variant={"default"}
      size="x-small"
      disabled={!isNotificationData}
    />
  ) : (
    <NotificationBellOutlined
      variant={_.isEqual(hoveredIcon, NOTIFICATIONS) ? "default" : "subtle"}
      size="x-small"
      disabled={!isNotificationData}
    />
  );
};

const getButtonIcon = (icon, badgeCount, selectedIcon) => {
  return (
    <>
      {icon}
      <Badge
        variant={
          _.isEqual(selectedIcon, HELP_CENTER) ? "subtle" : "notifications"
        }
        size={"medium"}
        value={badgeCount}
        type={"numeric"}
      />
    </>
  );
};

const getHelpCenterIcon = ({
  userLoggedIn,
  closeAllOptions,
  selectedIcon,
  sprinklrUnreadMessageCount,
  hoveredIcon,
}) => {
  return (
    <SupportDropdown
      userLoggedIn={userLoggedIn}
      trayMode={true}
      closeAllOptions={closeAllOptions}
      buttonIcon={
        _.isEqual(selectedIcon, HELP_CENTER)
          ? getButtonIcon(
              <HelpFilled size="x-small" variant={"default"} />,
              sprinklrUnreadMessageCount,
              selectedIcon
            )
          : getButtonIcon(
              <HelpOutlined
                size="x-small"
                variant={
                  _.isEqual(hoveredIcon, HELP_CENTER) ? "default" : "subtle"
                }
              />,
              sprinklrUnreadMessageCount,
              selectedIcon
            )
      }
    />
  );
};

export const checkIfShowNotificationInGlobalTrayEnabled = () => {
  return ACLStore.can("FeatureFlag:ShowNotificationInGlobalTray");
};
